(function() {
  function init() {
    const $ = jQuery;
    
    function updateAnnuallyPricing() {
      const $variantPicker = $('variant-selects');
      if (!$variantPicker.length) return;

      const $select = $variantPicker.find('select');
      const selectedValue = $select.val();

      // Only target the "Annually" option
      if (selectedValue !== 'Annually') {
        $('.appstle_single_option_text.custom-annually-price').remove();
        return;
      }

      // Small delay as requested
      setTimeout(function() {
        const scriptData = $variantPicker.find('script[type="application/json"]').html();
        if (!scriptData) return;

        try {
          const variants = JSON.parse(scriptData);
          const monthlyVariant = variants.find(v => v.title === 'Monthly');
          const annuallyVariant = variants.find(v => v.title === 'Annually');

          if (monthlyVariant && annuallyVariant) {
            const annualPrice = annuallyVariant.price / 100;
            const monthlyRateRaw = annualPrice / 12;

            if (isNaN(annualPrice) || isNaN(monthlyRateRaw)) return;

            // Detect decimal separator from the existing price display
            const priceText = $('.appstle_membership_amount .money').first().text();
            // If the text contains a comma and doesn't end with a dot-based decimal (e.g., .99), assume comma
            const decimalSeparator = priceText.includes(',') && !priceText.match(/\.\d{2}$/) ? ',' : '.';
            
            const formatPrice = (num) => {
              return num.toFixed(2).replace('.', decimalSeparator);
            };

            const monthlyRate = formatPrice(monthlyRateRaw);
            const formattedAnnualPrice = formatPrice(annualPrice);
            
            // Get currency symbol (defaulting to € based on the example provided)
            const currencySymbol = priceText.replace(/[0-9,.\s]/g, '').trim() || '€';
            
            const displayText = `Annually (${currencySymbol}${formattedAnnualPrice}) ${currencySymbol}${monthlyRate} per month`;

            // Update Appstle widget text if it exists
            const $appstleText = $('.appstle_single_option_text');
            if ($appstleText.length) {
              $appstleText.addClass('custom-annually-price').text(displayText);
            }
          }
        } catch (e) {
          console.error('Error parsing variant data', e);
        }
      }, 100);
    }

    $(document).on('change', 'variant-selects select', function() {
      updateAnnuallyPricing();
    });

    updateAnnuallyPricing();
  }

  // Check if jQuery is loaded, if not, wait for it
  if (window.jQuery) {
    init();
  } else {
    var checkInterval = setInterval(function() {
      if (window.jQuery) {
        clearInterval(checkInterval);
        init();
      }
    }, 50);
    
    // Stop checking after 5 seconds to prevent infinite loop
    setTimeout(function() {
      clearInterval(checkInterval);
    }, 5000);
  }
})();
